import { googleStart } from '../api/auth';

export const GOOGLE_FLOW_KEY = 'vbbplay.google_flow';

/** Redirect to Google; the binding stays in this tab so only this browser can finish the flow. */
export async function beginGoogle(purpose: 'login' | 'link'): Promise<void> {
  const { authorization_url, binding } = await googleStart(purpose);
  sessionStorage.setItem(GOOGLE_FLOW_KEY, JSON.stringify({ binding, purpose }));
  window.location.assign(authorization_url);
}
